import { z } from "zod";
import { emailSchema } from "./common";

// Forgot password form schema
export const createForgotPasswordFormSchema = () => {
  return z.object({
    email: z
      .string()
      .min(1, "Email is required")
      .pipe(emailSchema),
  });
};

// Reset password form schema
export const createResetPasswordFormSchema = () => {
  return z.object({
    password: z
      .string()
      .min(1, "Password is required")
      .min(6, "Password must be at least 6 characters")
      .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/, "Password must contain at least one uppercase letter, one lowercase letter, and one number"),
    confirmPassword: z
      .string()
      .min(1, "Confirm password is required")
  }).refine((data) => data.password === data.confirmPassword, {
    message: "Passwords do not match",
    path: ["confirmPassword"],
  });
};


// Simple validation schema for email verification actions
export const emailVerificationSchema = z.object({
  email: emailSchema.min(1, "Email is required"),
  action: z.enum(["resend", "login", "edit", "update", "contact"], {
    required_error: "Please select an action"
  }),
});